export const get_all_category_key_name = function (tabName) {
  return `All in ${tabName}`;
};
export const checkCategoryAdded = (categoryData) => {
  let index = null;
  for (let i = 0; i < categoryData?.length; i++) {
    if (
      categoryData[i].subCategories &&
      categoryData[i].subCategories?.length > 0
    ) {
      index = i;
      break;
    }
  }
  if (index === null) {
    return false; // don't fetch again
  }
  if (
    categoryData[index].subCategories?.[0]?.tabName ==
    get_all_category_key_name(categoryData[index]?.tabName)
  ) {
    return true;
  }
  return false;
};
export const addOneSubCategory = (categoryData) => {
  const data = modifySubCategories(categoryData);
  return JSON.parse(JSON.stringify(data));
};

const modifySubCategories = (categoryData, childNode) => {
  const data = categoryData.map((element) => {
    // element is store or if it is already a child node
    if (element.type == '1' || childNode) {
      let category_copy = {
        ...element,
        tabName: get_all_category_key_name(element.tabName),
      };
      category_copy.subCategories = null;
      if (element.subCategories) {
        // if type is not store then update sub categories
        if (element.type != 1) {
          element.subCategories = [category_copy, ...element.subCategories];
        }

        element.subCategories = modifySubCategories(
          element.subCategories,
          true,
        );
      }
    }
    return element;
  });
  return data;
};
